import React from "react";
import Hero from "./Hero/Hero";
import Info from "./Info/Info";

const Landing = () => {
  return (
    <>
      <Hero />
      <Info />
    </>
  );
};

export default Landing;
